import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Settings';
import block from 'propmods';

import { devicesApi } from '../../api';
import { useSettingsPageContext } from '../../context/settingsPageContext';
import { useCurrentAliceApp } from '../../hooks/useCurrentAliceApp';
import { useFetchingHandler } from '../../hooks/useFetchingHandler';
import { MarketDevice, MarketDeviceStatus } from '../../model/devices';
import Link from '../Link/Link';
import { Loading } from '../Loading/Loading';

import MinusIcon from '../../icons/minus.svg';

import './DeviceLinkingCard.scss';

const b = block('DeviceLinkingCard');
const t = i18n(keyset);

interface DeviceLinkingCardProps {
    device: MarketDevice;
    afterRemove?: () => void;
    disabled?: boolean;
}

export const DeviceLinkingCard: React.FC<DeviceLinkingCardProps> = ({ device, afterRemove, disabled }) => {
    const { marketId, picture, title, status, vendorName } = device;
    const skill = useCurrentAliceApp()!;
    const { isDraft } = useSettingsPageContext();
    const url = `${__appConfig.app.marketFrontentUrl}/product/${marketId}`;

    const [deleteDeviceHandler, removeState] = useFetchingHandler({
        handler: () =>
            isDraft
                ? devicesApi.deleteDevice(skill.id, marketId, skill.channel)
                : devicesApi.deletePublishedDevice(skill.id, marketId, skill.channel),
        afterLoad: () => afterRemove?.(),
    });

    const isNotFound = status === MarketDeviceStatus.NOT_FOUND;

    return (
        <div {...b()}>
            <div {...b('logo-frame', { hidden: isNotFound })}>
                <div {...b('logo')}>{!isNotFound && <img src={picture} {...b('image')} />}</div>
            </div>
            <div {...b('content')}>
                <div {...b('title')}>
                    {isNotFound ? (
                        <div {...b('error')}>{t('devices-error-not_found')}</div>
                    ) : (
                        <Link to={url} target="_blank">
                            {title}
                        </Link>
                    )}
                </div>
                {Boolean(vendorName) && <div {...b('vendor')}>{vendorName}</div>}
                <div {...b('id')}>ID {marketId}</div>
            </div>
            <div onClick={deleteDeviceHandler} {...b('remove', { disabled, error: isNotFound })}>
                {removeState === 'loading' ? <Loading size="xxs" /> : <MinusIcon />}
            </div>
        </div>
    );
};
